
import { Camera, Image as ImageIcon, User } from "lucide-react";
import { cn } from "@/lib/utils";

export const UserPlaceholder = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="100" height="100" className="fill-zinc-300 dark:fill-muted" />
      <circle cx="50" cy="40" r="20" className="fill-foreground" />
      <path d="M20,80 C20,60 80,60 80,80 V100 H20 Z" className="fill-foreground" />
    </svg>
  );

export function PlaceholderMedia({ type = 'image', className }: { type?: 'image' | 'banner' | 'user', className?: string }) {
  const isBanner = type === 'banner';

  const baseClasses = "w-full h-full flex items-center justify-center";
  
  if (type === 'user') {
    return (
        <div className={cn(baseClasses, "border-none bg-muted", className)}>
            <UserPlaceholder className="w-full h-full"/>
        </div>
    )
  }
  
  const iconColor = "text-muted-foreground/80";
  const backgroundColor = "bg-muted";

  return (
    <div className={cn(baseClasses, backgroundColor, className, "rounded-lg")}>
       <div className={cn("text-center", iconColor)}>
        <ImageIcon className="h-8 w-8 mx-auto"/>
      </div>
    </div>
  )
}
